const Card = ({ title, value, subValue, flexBasis }) => {
    return (
      <div style={{ 
        backgroundColor: '#A7F3D0',
        border: '1px solid #9bbb59',
        borderRadius: '8px',
        padding: '10px',
        width: '200px',
        textAlign: 'center',
        margin: '10px',
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.1)',
        flexBasis: flexBasis
      }}>
        <h3 style={{ margin: '0 0 5px 0', fontSize: '1.1em' }}>{title}</h3>
        <div style={{ fontSize: '1em', fontWeight: 'bold' }}>{value}</div>
        {subValue && subValue?.map(val => <div style={{ marginTop: '5px' }}>{val}</div>)}
      </div>
    );
  };

  export default Card;